import { render, staticRenderFns } from "./listing-statistics-goods.vue?vue&type=template&id=cf2ad268&scoped=true&"
import script from "./listing-statistics-goods.vue?vue&type=script&lang=js&"
export * from "./listing-statistics-goods.vue?vue&type=script&lang=js&"
import style0 from "./listing-statistics-goods.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./listing-statistics-goods.vue?vue&type=style&index=1&id=cf2ad268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2ad268",
  null
  
)

export default component.exports